app.filter('timed', function (ChatService) {
    return function (duration) {
        const _h = Math.floor(duration);
        const _m = (duration - _h) * 60;
        const hours = `${_h} ${_h > 1 ? 'hrs' : 'hr'}`;
        const minutes = `${_m} ${_m > 1 ? 'mins' : 'min'}`;
        return `${_h > 0 ? hours : ''} ${_m > 0 ? minutes : ''}`;
    };
});
